import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground border-border",
        accent: "border-transparent bg-accent text-accent-foreground",
        success: "border-transparent bg-success text-success-foreground",
        tech: "border-transparent bg-category-tech/10 text-category-tech",
        sales: "border-transparent bg-category-sales/10 text-category-sales",
        admin: "border-transparent bg-category-admin/10 text-category-admin",
        health: "border-transparent bg-category-health/10 text-category-health",
        education: "border-transparent bg-category-education/10 text-category-education",
        logistics: "border-transparent bg-category-logistics/10 text-category-logistics",
        featured: "border-accent bg-accent/10 text-accent font-semibold",
        new: "border-transparent bg-success/10 text-success font-semibold",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
